<template>
  <div id="top" class="main_div">
    <ContentHeader class="content" />
    <div :class="gallery">
      <div v-for="item2 in renderItems" :key="item2.id">
        <h2 class="date_title">{{dates[item2]}}</h2>
        <v-layout row wrap justify-center>
          <v-flex xs5 sm5 md3 lg3 v-for="item in selectedPhotos[item2]" :key="item.id">
              <router-link :to="{ name: 'CarouselRecent', params: {date: item2, index: item[1]}}">
                <v-card class="ml-1 mt-1 mr-1 cards" tile>
                  <v-img class="photo" :src="item[0]" :aspect-ratio="16/9">
                  </v-img>
                </v-card>
              </router-link>
          </v-flex>
        </v-layout>
        <v-divider class="mt-8"></v-divider>
      </div>
      <v-layout>
        <Footer class="footer mt-5" />
      </v-layout>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "GalleryRecent",
  data() {
    return {
      lang: this.$route.params.lang,
      data: []
    };
  },
  components: {
    ContentHeader,
    Footer
  },

  mounted() {
    this.$store.dispatch("getPhotos");
  },
  computed: {
    ...mapState(["carouselRecent"]),
    photos() {
      return this.$store.state.photos;
    },
    selectedPhotos() {
      this.init();
      var res = {};
      for (var i = 0; i < this.data.length; i++) {
        res[this.data[i]] = [];
      }

      for (i = 0; i < this.photos.length; i++) {
        if (
          this.data.includes(
            Number(
              String(this.photos[i]["datum"].slice(0, 4)) +
                String(this.photos[i]["datum"].slice(5, 7)) +
                String(this.photos[i]["datum"].slice(8, 11))
            )
          ) &&
          this.photos[i]["recent"]
        ) {
          res[
            Number(
              String(this.photos[i]["datum"].slice(0, 4)) +
                String(this.photos[i]["datum"].slice(5, 7)) +
                String(this.photos[i]["datum"].slice(8, 11))
            )
          ].push([this.photos[i]["image"], this.photos[i]["id"]]);
        }
      }

      this.SET_CAROUSELRECENT(res)

      return res;
    },
    renderItems() {
      var res = [];
      for (var i = 0; i < Object.keys(this.selectedPhotos).length; i++) {
        if (
          this.selectedPhotos[Object.keys(this.selectedPhotos)[i]].length > 0
        ) {
          res.push(Object.keys(this.selectedPhotos)[i]);
        }
      }
      res.sort().reverse();
      return res;
    },
    dates(){
        var res ={}
        for(var i=0; i<this.renderItems.length;i++){
            console.log(this.renderItems[i])
            console.log(this.renderItems[i].slice(4, 6))
            if(this.lang=='en'){
                if(this.renderItems[i].slice(4, 6) == "01"){
                res[this.renderItems[i]] = "January" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
            }
                if(this.renderItems[i].slice(4, 6) == "02"){
                    res[this.renderItems[i]] = "February" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "03"){
                    res[this.renderItems[i]] = "March" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "04"){
                    res[this.renderItems[i]] = "April" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "05"){
                    res[this.renderItems[i]] = "May" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "06"){
                    res[this.renderItems[i]] = "June" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "07"){
                    res[this.renderItems[i]] = "July" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "08"){
                    res[this.renderItems[i]] = "August" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "09"){
                    res[this.renderItems[i]] = "September" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "10"){
                    res[this.renderItems[i]] = "October" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "11"){
                    res[this.renderItems[i]] = "November" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "12"){
                    res[this.renderItems[i]] = "December" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
            }else{
                if(this.renderItems[i].slice(4, 6) == "01"){
                res[this.renderItems[i]] = "Januari" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "02"){
                    res[this.renderItems[i]] = "Februari" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "03"){
                    res[this.renderItems[i]] = "Maart" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "04"){
                    res[this.renderItems[i]] = "April" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "05"){
                    res[this.renderItems[i]] = "Mei" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "06"){
                    res[this.renderItems[i]] = "Juni" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "07"){
                    res[this.renderItems[i]] = "Juli" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "08"){
                    res[this.renderItems[i]] = "Augustus" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "09"){
                    res[this.renderItems[i]] = "September" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "10"){
                    res[this.renderItems[i]] = "Oktober" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "11"){
                    res[this.renderItems[i]] = "November" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
                if(this.renderItems[i].slice(4, 6) == "12"){
                    res[this.renderItems[i]] = "December" + " " + String(this.renderItems[i].slice(6, 9)) + ", " + String(this.renderItems[i].slice(0, 4))
                }
            }
            
        }

        return res
    },
    gallery() {
      return "photos_gallery";
    }
  },
  methods: {
    ...mapMutations(["SET_CAROUSELRECENT"]),
    init() {
      var datums = [];
      var dat;
      for (var i = 0; i < this.photos.length; i++) {
        dat = Number(
          String(this.photos[i]["datum"].slice(0, 4)) +
            String(this.photos[i]["datum"].slice(5, 7)) +
            String(this.photos[i]["datum"].slice(8, 11))
        );

        if (!datums.includes(dat)) {
          datums.push(dat);
        }
      }
      datums = datums.sort().reverse();
      datums = datums.slice(0, 11);
      this.data = datums;
    },
    update(){
        this.lang = this.$route.params.lang;
    },
  },
watch: {
        $route: "update"
    },
  
};
</script>

<style scoped>
.photo {
  transform: scale(1.05);
  transition: transform 0.5s;
}
.footer {
  width: 100%;
}
.date_title{
    margin-top: 20px;
}
.title {
  position: absolute;
  top: 12%;
  left: 43%;
}
.content {
  width: 100%;
  height: 10%;
  background-color: black;
  position: absolute;
  top: 0%;
}

.cards {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.photo:hover {
  transform: scale(1.15);
}

.photos_gallery_port {
  position: absolute;
  width: 100%;
  top: 26%;
}

.photos_gallery {
  position: absolute;
  width: 100%;
  top: 10%;
}
</style>